import { useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import "../Styles/component.css";
import "../Styles/fonts.css";
import "../Styles/global.css";
import "../Styles/lists.css";
import { postJson } from "../Utils/apiUtils";

const UpdateCashInfoBox = ({ handleClickX, paymentId }) => {
  const navigate = useNavigate();

  const [cashNo, setCashNo] = useState("");
  const [cashEmail, setCashEmail] = useState("");

  const updateCashInfo = async () => {
    try {
      const body = {
        paymentId,
        cashNo,
        cashEmail,
      };

      const res = await postJson(
        "/dashboard/gifticonOrder/updateCashInfo",
        body,
        navigate
      );

      if (res.code === 200) {
        handleClickX();
      }
    } catch (error) {
      console.error("현금영수증 정보 수정 중 에러:", error);
    }
  };

  return (
    <Box>
      <div className="hrz-wrapper center">
        <p className="bold-text" style={{ fontSize: "24px" }}>
          현금영수증 발급 정보 수정
        </p>
      </div>
      <div className="hrz-wrapper" style={{ marginTop: "-32px" }}>
        <div style={{ marginLeft: "auto", cursor: "pointer" }}>
          <IconCrossRound onClick={handleClickX} />
        </div>
      </div>

      <p className="medium-text" style={{ marginTop: "30px" }}>
        사업자 번호
      </p>
      <div
        style={{
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          width: "500px",
          height: "55px",
          marginTop: "14px",
          borderRadius: "10px",
        }}
        className="center"
      >
        <input
          type="text"
          placeholder="사업자번호 10자리를 입력해주세요(‘-’ 제외)"
          style={{ outline: "none", border: "none", width: "470px" }}
          onChange={(e) => setCashNo(e.target.value)}
        />
      </div>

      <p className="medium-text" style={{ marginTop: "14px" }}>
        발급 이메일
      </p>
      <div
        style={{
          boxShadow: "inset 0 0 0 1px #e4e4e4",
          width: "500px",
          height: "55px",
          marginTop: "14px",
          borderRadius: "10px",
        }}
        className="center"
      >
        <input
          type="text"
          placeholder="발급받을 이메일을 입력해주세요"
          style={{ outline: "none", border: "none", width: "470px" }}
          onChange={(e) => setCashEmail(e.target.value)}
        />
      </div>

      <div
        className="blueBtn-base"
        style={{
          marginTop: "30px",
          width: "500px",
          height: "60px",
          borderRadius: "10px",
        }}
        onClick={updateCashInfo}
      >
        저장
      </div>
    </Box>
  );
};

const UpdateCashInfo = ({ handleClickX, paymentId }) => {
  return (
    <LayoutModal
      Modal={
        <UpdateCashInfoBox handleClickX={handleClickX} paymentId={paymentId} />
      }
    />
  );
};

const Box = styled.div`
  padding: 30px;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
`;

export default UpdateCashInfo;
